import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import {Redirect} from 'react-router-dom'
import qs from 'query-string';
import UserProfile from '../Configuration/UserProfile'
import Cookies from 'universal-cookie'
import moment from "moment"
import * as pbi from 'powerbi-client';
import * as models from 'powerbi-models';

// import qs from 'query-string';

class Frame extends Component {
    constructor() {
        super()

        this.state = {
          is_loaded: false ,
          reportinfo: null       
        }
    
    }   

    componentDidMount() {
        const rid = this.props.match.params.rid;
        const gid = this.props.match.params.gid;
        const uri = config.getUriPath('visualizations/embedToken?id=' + rid + '&group_id=' + gid)
        var that = this;  
        //report info
        var reportname = ''
        
        let vizuri = config.getAcumenAPIURL('reports/' + rid);        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 
        
        fetch(vizuri, {
                method: 'get',
                headers: myHeaders
               }).then(function(response) {
                    if (response.status >= 400) {
                    throw new Error("Bad response from server");
                    }
                    return response.json();
              })
              .then(function(data) {
               console.log('report info loaded')               
               reportname = data.report.name;
               that.setState({ is_loaded: true, reportinfo: data.report });                   
               return;
            });
        
        const desktopLayout = models.LayoutType.Custom;
        var thisLayout = desktopLayout;        
        var v_viewMode = models.ViewMode.View;
        var v_Permissions = models.Permissions.All;

        //embed token

        var raw = JSON.stringify({
			"group_id": gid,
			"report_id": rid,
			"accesslevel": "view",
			"allowsaveas": "false"
		});	
		
        var eHeaders = new Headers();
        eHeaders.append("Content-Type", "application/json");
        eHeaders.append("x-api-key", "uZtu9iISFC9VpKV3zzvEs1bb6LSAj3wW8EAGk1zI"); 
        
        fetch("https://api.apiacumen.com/api/pbitoken", {
            method: 'POST',
            headers: eHeaders,
            body:raw,
            redirect: 'follow'
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            if (response.status >= 204) {
                return null;
            }

            return response.json();
          })
          .then(function(data) {
            if (data == null) {
                return;
            }
            console.log(data)    
            const embedUrl = "https://app.powerbi.com/reportEmbed?reportId=" + rid + "&groupId=" + gid;

            var pbiconfig = {
                type: 'report',
                tokenType: 1,
                accessToken: data.body,
                embedUrl: embedUrl,
                id: rid,
                permissions: v_Permissions,
                viewMode: v_viewMode,
                settings: {
                  filterPaneEnabled: true,
                  navContentPaneEnabled: true,
                  //background: 1,                  
                  layoutType: thisLayout,
                  panes: {
                    pageNavigation: {visible: true, position: 1}
                    }
                  }
                };

                let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
                var reportContainer = document.getElementById('rptContainer');
                
               var report = powerbi.embed(reportContainer, pbiconfig); 
               report.on("saved", function (event) {
                 console.log(event.detail);
                 if (event.detail.saveAs) {
                    console.log('redirect to new report');
                 }
               });
               report.on("loaded", function (event) {
                document.title = reportname;
               });
               report.on("error", function (event) {
                console.log(event.detail);                
               });   
          });
          
    }

    render() {
        return <div>
                    <header className="fixedheader">
                        <div className="grid-wrapper">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col">
                                        <a href="/"><img className="" src="/logos/white.png" alt="Logo" /></a>
                                    </div>
                                    <div className="topmenu">
                                        <div className="megamenu">
                                            <button className="dropbtn-modules">Modules&nbsp;<i className="fa fa-caret-down"></i></button>
                                            <div className="modules-menu">
                                                <div className="flex-container-sml">
                                                    <div className="flex-container-item-sml">
                                                        <div className="ModuleMIHead">Acumen Core</div>
                                                        <div className="ModuleMISub"><a href="/visualizations/view/0fa37a73-37ad-406d-81a9-e22d6e237ba0/1c54e901-1ed9-472a-813d-2a8725dc7915" target="_self">Membership - Individual</a></div>
                                                        <div className="ModuleMISub"><a href="/visualizations/view/9d058496-6d31-4915-83ef-07b436d8bc68/1c54e901-1ed9-472a-813d-2a8725dc7915" target="_self">Sales</a></div>
                                                        <div className="ModuleMISub"><a href="/visualizations/view/81938cef-d08d-43bf-ab53-3446df471f1e/1c54e901-1ed9-472a-813d-2a8725dc7915" target="_self">Sales Overlap</a></div>
                                                    </div>
                                                    <div className="flex-container-item-sml">
                                                        <div className="ModuleMIHead">Acumen Plus</div>
                                                        <div className="ModuleMISub"><a href="/visualizations/view/2564ad54-3150-4603-af6c-227c817ab38a/1c54e901-1ed9-472a-813d-2a8725dc7915" target="_self">Community</a></div>
                                                        <div className="ModuleMISub"><a href="/visualizations/view/d8fbe62e-d110-428c-be70-4209e87bd1a4/1c54e901-1ed9-472a-813d-2a8725dc7915" target="_self">Learning</a></div>
                                                    </div>
                                                    <div className="flex-container-item-sml">
                                                        <div className="ModuleMIHead">Administration</div>
                                                        <div className="ModuleMISub"><a href="/admin/users/d2d1fe60-7702-416d-af5a-cef82dac04f0" target="_self">Users</a></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <a href="https://a2acumen.atlassian.net/servicedesk/customer/portal/5" target="_blank"><div className="dropbtn-support">Support</div></a>
                                        <div className="megamenu"><button className="dropbtn-community">Community&nbsp;<i className="fa fa-caret-down"></i></button>
                                            <div className="community-menu">
                                                <div className="flex-container-sml">
                                                    <div className="flex-container-item-sml">
                                                        <div className="ModuleMISub"><a href="https://community.getacumen.com/communities/community-home/librarydocuments?LibraryKey=830f1f1b-53a3-45a0-8ee0-54fdf24534b1" target="_blank">Knowledge Base</a></div>
                                                        <div className="ModuleMISub"><a href="https://community.getacumen.com/participate/postmessage?ReturnUrl=https%3a%2f%2fcommunity.getacumen.com%2fbrowse%2fallrecentposts" target="_blank">Post in the Community</a></div>
                                                        <div className="ModuleMISub"><a href="https://community.getacumen.com/browse/blogs" target="_blank">Release Notes</a></div>
                                                        <div className="ModuleMISub"><a href="https://community.getacumen.com/browse/ideation-home" target="_blank">Product Ideas</a></div>
                                                        <div className="ModuleMISub"><a href="https://community.getacumen.com/browse/roadmap" target="_blank">Roadmap</a></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="hidden">
                                            <button className="dropbtn-fullscreen" name="fullscreen">
                                                <img className="fullscreen" src="/logos/fullscreen.png" alt="Full Screen" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <img className="acumenpoweredbylogo" src="/logos/acumen_powered_by.png" alt="Powered By Acumen" />
                                    </div>
                                </div>
                                <div className="row headersecondrow">
                                    <div className="col">
                                        <div></div>
                                    </div>
                                <div className="col">
                                    <nav className="navbar navbar-expand-lg navbar-light">
                                        <div className="account-menu">
                                            <a className="account-menu-toggle" href="#account-toggle" data-toggle="collapse" aria-expanded="false">
                                                <span>d2l_acumen@getacumen.com</span>
                                                <i className="fas fa-angle-down profilearrow"></i>
                                            </a>
                                            <ul className="collapse list-unstyled" id="account-toggle">
                                                <li>
                                                    <a href="/profile">Profile</a>
                                                </li>
                                                <li><a href="/profile/password/change">Change Password</a></li>
                                                <li><a href="/signout">Sign Out</a></li>
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    </header>
                    <div className="center-div">
                        <div className="rptContainer" id="rptContainer">&nbsp;</div>
                    </div>
                </div>
    }
}

export default Frame


// WEBPACK FOOTER //
// ./src/Components/Frame/frame.js